import { Table } from "antd";
import React, { useState } from "react";

const AntDesignTable = (props) => {
  const { columns, tableData, setSelectedRowKeys } = props;
  const [selectionType, setSelectionType] = useState("checkbox");
  const [selectedRowKeys, setSelectedRowKeysLocal] = useState([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeysLocal(newSelectedRowKeys);
      setSelectedRowKeys(newSelectedRowKeys);
      console.log(
        `selectedRowKeys: ${newSelectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  return (
    <React.Fragment>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={tableData}
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
      />
    </React.Fragment>
  );
};

export default AntDesignTable;
